import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";
import { IMedia } from "~/util/providers/photo";
import { unsetDetail } from "~/state/detail/state";
import { store } from "~/photo/globals";
import { getIcon } from "~/util/providers/poiagg";
import { CONFIG } from "~/config";

export function generatePoiLinkContainer(data: IMedia): HTMLDivElement {
	const container = node("div", { className: `poi` });
	const link = node(data.mark ? "a" : "span", { className: "photo-poi-link" });
	const coorsLink = () => {
		const typeIcon = icon("pin-color");
		const text = node("span", {}, _("detail.titleCoor"));

		link.classList.add("coor");
		link.append(typeIcon, text);

		if (data.mark) {
			link.setAttribute("href", `https://${CONFIG.BASE_URL}/?source=coor&id=${data.mark.lon},${data.mark.lat}`);
		}
	};

	link.setAttribute("data-log-ignore", "1");

	if (data.entitySource === "coor") {
		coorsLink();
	} else {
		const poiIcon = getIcon(data.entityPoiTypeId);

		if (poiIcon) {
			const img = node("img", { src: poiIcon, srcset: `${poiIcon} 1x, ${poiIcon}${poiIcon.indexOf("?") === -1 ? "?" : "&"}scale=2 2x` });
			const text = node("span", {}, data.entityTitle);

			link.setAttribute("href", `https://${CONFIG.BASE_URL}/?source=${data.entitySource}&id=${data.entityId}`);
			link.append(img, text);
		} else {
			coorsLink();
		}
	}

	if (data.entitySource !== "coor" || data.mark) {
		link.addEventListener("click", (event: MouseEvent) => {
			event.preventDefault();

			const galleryComponent = Mapy.getComponent("gallery");
			const logData = galleryComponent.isActive() ? galleryComponent.logData : Mapy.getComponent("photoDetail").options?.galleryType ? { galleryType: Mapy.getComponent("photoDetail").options.galleryType } : {};
			const galleryData = galleryComponent.getData();
			const galleryState = galleryComponent.getState();
			const returnState = {
				sourcep: data.source,
				idp: data.id,
				forceHistorySave: true,
				...galleryState,
				...galleryData,
			};

			Mapy.getComponent("logger").log("gallery_to_detail", {
				galleryType: "photomap",
				section: "gallery",
				...logData,
				place: "detail",
				type: data.entitySource === "coor" ? "gps" : "poi",
			});

			Mapy.getComponent("detail").setState({
				source: data.entitySource,
				id: data.entitySource === "coor" ? `${data.mark.lon},${data.mark.lat}` : data.entityId,
				backTitle: _("back"),
				backAction: () => {
					const detailState = store.getState().detail;

					galleryData.source !== detailState.source && galleryData.id !== detailState.id && store.dispatch(unsetDetail());
					Mapy.getComponent("gallery").setState(returnState);
					!galleryData.source && Mapy.getComponent("photoDetail").setState({
						...logData,
						...returnState,
					});
					Mapy.getComponent("history").save();

					Mapy.getComponent("logger").log("gallery_return_from_detail", {
						galleryType: "photomap",
						section: "gallery",
						...logData,
						place: "detail",
						type: data.entitySource === "coor" ? "gps" : "poi",
					});
				},
			}).then(() => {
				Mapy.getComponent("history").save();
			}, () => {});

			Mapy.getComponent("userProfile").deactivate();
			Mapy.getComponent("photoDetail").close("open_detail");
			Mapy.getComponent("gallery").close("open_detail");
		}, false);
	}

	container.append(link);

	return container;
}
